import { EnrollmentContext } from './EnrollmentContext'
import { OrganizationContextProvider } from '@BUP/contexts/OrganizationContext'
import { RoleContextProvider } from '@BUP/contexts/RoleContext'
import { LocationContextProvider } from './LocationContext'
import { CurrentTermContextProvider } from './CurrentTermContext'
import { IntercomProvider } from 'react-use-intercom'
import intercomConfig from '@BUP/configs/intercom'

const BraveupContextsComponent = ({
  enrollment,
  role,
  roleLoading,
  children
}) => {
  return (
    <EnrollmentContext.Provider value={enrollment}>
      <OrganizationContextProvider>
        <LocationContextProvider>
          <CurrentTermContextProvider>
            <IntercomProvider appId={intercomConfig.appId}>
              <RoleContextProvider
                role={role}
                roleLoading={roleLoading}
              >
                {children}
              </RoleContextProvider>
            </IntercomProvider>
          </CurrentTermContextProvider>
        </LocationContextProvider>
      </OrganizationContextProvider>
    </EnrollmentContext.Provider>
  )
}

export default BraveupContextsComponent
